import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-2-line text-xl text-accent-500"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-background-50">
                  姨母的诱惑
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                专注于成人情感文学的精品推荐平台。我们相信，优秀的文学作品能够穿越世俗的迷雾，触及人性最深的真实。为成熟读者甄选每一个值得品味的故事。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      onClick={handleNavClick}
                      className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                快捷链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/"
                    onClick={handleNavClick}
                    className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200"
                  >
                    首页推荐
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    onClick={handleNavClick}
                    className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#newsletter"
                    className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200"
                  >
                    邮件订阅
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200"
                  >
                    用户协议
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                联系我们
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-sm text-accent-500"></i>
                  </div>
                  contact@guangzhousoap.cn
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-wechat-line text-sm text-accent-500"></i>
                  </div>
                  微信公众号：姨母的诱惑
                </li>
                <li>
                  <Link
                    to="/about"
                    onClick={handleNavClick}
                    className="inline-flex items-center gap-1 text-sm text-accent-500 hover:text-accent-400 transition-colors duration-200"
                  >
                    了解更多
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 姨母的诱惑. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-accent-500 transition-colors">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-weibo-line"></i>
                </div>
              </a>
              <a href="#" className="text-background-500 hover:text-accent-500 transition-colors">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-reddit-line"></i>
                </div>
              </a>
              <a href="#" className="text-background-500 hover:text-accent-500 transition-colors">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-rss-line"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}